/* eslint-disable no-console */
<template>

    <div class="main_unit">
        <div class="admin_menu_top_unit menu_center">
            <Message v-if="ApivalidationMessage || !this.addFormFlg" :validationMessage="alertMessage" /><br>
            <Message v-if="ApivalidationMessage" :validationMessage="ApivalidationMessage" />

            <form class="form_companyBrand" v-on:submit.prevent="onsubmit">
                <div class="lavel_companyBrand right_comment">
                    <img class="required" src="../assets/required.png" />
                    <label for="companyid">企業コード</label>
                </div>
                <div class="input_companyBrand left_comment">
                    <input  class="wd240" id="companyid" name="companyid" type="text" v-model="addBrandForm.brand_id" maxlength="20"/><br>
                    <label id="companyiderror" class="lavel_error_font ">{{validation.companyidReult}}</label>
                </div>

                <div class="lavel_companyBrand right_comment">
                    <img class="required" src="../assets/required.png" />
                    <label for="company_name">企業名</label>
                </div>
                <div class="input_companyBrand left_comment">
                    <input  class="wd240" id="company_name" name="company_name" type="text" v-model="addBrandForm.company_name" maxlength="40"/><br>
                    <label >企業名は、40桁以内かつ全半角英数漢ひらカナ記号（・-ー&＆'’,，.．）スペースで入力してください。</label>
                    <label id="company_nameerror" class="lavel_error_font ">{{validation.companyNameReult}}</label>
                </div>

                <div class="lavel_companyBrand right_comment">
                    <img class="required" src="../assets/required.png" />
                    <label for="companyurl">URL</label>
                </div>
                <div class="input_companyBrand left_comment">
                    <input  class="wd240" id="companyurl" name="companyurl" type="text" v-model="addBrandForm.url" maxlength="100"/><br>
                    <label id="companyurlerror" class="lavel_error_font ">{{validation.companyurlReult}}</label>
                </div>

                <div class="lavel_companyBrand right_comment">
                    <img class="required" src="../assets/required.png" />
                    <label for="companybrand_name">ブランド名</label>
                </div>
                <div class="input_companyBrand left_comment">
                    <input  class="wd240" id="companybrand_name" name="companybrand_name" type="text" v-model="addBrandForm.brand_name" maxlength="40"/><br>
                    <label >ブランド名は、40桁以内かつ全半角英数漢ひらカナ記号（・-ー&＆'’,，.．）スペースで入力してください。</label>
                    <label id="companybrand_nameerror" class="lavel_error_font ">{{validation.companybrand_nameReult}}</label>
                </div>

                <div class="lavel_companyBrand right_comment">
                    <label for="companypostalcode">郵便番号</label>
                </div>
                <div class="input_companyBrand left_comment">
                    <input  class="wd240" id="companypostalcode" name="companypostalcode" type="text" v-model="addBrandForm.zip_code" maxlength="7"/><br>
                    <label>半角数字(ハイフンなし)で入力してください。</label>
                    <label id="companypostalcodeerror" class="lavel_error_font ">{{validation.companypostalcodeReult}}</label>
                </div>

                <div class="lavel_companyBrand right_comment">
                    <label for="companyaddress">企業住所</label>
                </div>
                <div class="input_companyBrand left_comment">
                    <input  class="wd240" id="companyaddress" name="companyaddress" type="text" v-model="addBrandForm.address" maxlength="40"/><br>
                    <label id="companyaddresserror" class="lavel_error_font ">{{validation.companyaddressReult}}</label>
                </div>

                <div class="lavel_companyBrand right_comment">
                    <label for="companydepartmentname">担当部署</label>
                </div>
                <div class="input_companyBrand left_comment">
                    <input  class="wd240" id="companydepartmentname" name="companydepartmentname" type="text" v-model="addBrandForm.department_name" maxlength="30"/><br>
                    <label id="companydepartmentnameerror" class="lavel_error_font ">{{validation.companydepartmentnameReult}}</label>
                </div>


                <div class="lavel_companyBrand right_comment">
                    <label for="companyｒemarks">備考欄</label>
                </div>
                <div class="input_companyBrand left_comment">
                    <input  class="wd240" id="companyｒemarks" name="companyｒemarks" type="text" v-model="addBrandForm.remarks" maxlength="20"/><br>
                    <label id="companyｒemarkserror" class="lavel_error_font ">{{validation.companyremarksReult}}</label>
                </div>

                <div class="lavel_companyBrand right_comment">
                    <label for="companytell">連絡先電話番号</label>
                </div>
                <div class="input_companyBrand left_comment">
                    <input  class="wd240" id="companytell" name="companytell" type="text" v-model="addBrandForm.phone_number" maxlength="11"/><br>
                    <label>半角数字(ハイフンなし)で入力してください。</label>
                    <label id="companytellerror" class="lavel_error_font ">{{validation.companytellReult}}</label>
                </div>

                <div class="lavel_companyBrand right_comment">
                    <img class="required" src="../assets/required.png" />
                    <label for="companypass">企業管理者パスワード</label>
                </div>
                <div class="input_companyBrand left_comment">
                    <input  class="wd240" id="companypass" name="companypass" type="password" v-model="addBrandForm.company_manager_pw" maxlength="128"/><br>
                    <label>パスワードは、8桁以上128桁以内かつ半角英数記号(!"#$%&'()*+,-./:;&lt;=&gt;?@[]^_`{|}~)で入力してください。</label>
                    <label id="companypasserror" class="lavel_error_font ">{{validation.companypassReult}}</label>
                </div>

                <div class="lavel_companyBrand right_comment">
                    <img class="required" src="../assets/required.png" />
                    <label for="companyrepass">企業管理者パスワード(確認用)</label>
                </div>
                <div class="input_companyBrand left_comment">
                    <input  class="wd240" id="companyrepass" name="companyrepass" type="password" v-model="addBrandForm.company_manager_pw_confirm" maxlength="128"/><br>
                    <label id="companyrepasserror" class="lavel_error_font ">{{validation.companyrepassReult}}</label>
                </div>

                <div class="lavel_companyBrand right_comment">
                  <label for="companyurl">帳票複製企業URL</label>
                </div>
                <div class="input_companyBrand left_comment">
                  <input  class="wd240" id="companyurl" name="companyurl" type="text" v-model="addBrandForm.daily_duplication_company_url" maxlength="100"/><br>
                  <label id="companyurlerror" class="lavel_error_font ">{{validation.companydailyduplicationcompanyurlReult}}</label>
                </div>

                <div class="lavel_companyBrand right_comment">
                    <label for="heatStrokeSet">熱中症アラート使用</label>
                </div>
                <div class="input_companyBrand left_comment">
                    <div class="form-check form-check-inline wd70">
                        <input class="form-check-input display_radio" id="heatStrokeSet_id1" name="checkdis" type="radio" value='1' v-model="addBrandForm.heat_stroke_enable">
                        <label class="form-check-label" for="heatStrokeSet_id1">有</label>
                    </div>
                    <div class="form-check form-check-inline wd70">
                        <input class="form-check-input display_radio" id="heatStrokeSet_id2" name="checkdis" type="radio" value='0' v-model="addBrandForm.heat_stroke_enable">
                        <label class="form-check-label" for="heatStrokeSet_id2">無</label>
                    </div>
                    <br>
                    <label id="heatStrokeSeterror" class="lavel_error_font ">{{validation.companyHeatStrokeEnableResult}}</label>
                </div>

            </form>
        </div>
        <div class="btn_submit letter_spa">
            <a href="#" @click.prevent.stop="checkFrom">登録</a>
        </div>
        <div class="overlay" v-show="showContent">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">企業登録</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>企業登録が完了しました。</p>
                    </div>

                    <div class="btn_submit">
                        <a href="#" @click.prevent.stop="closeModel">OK</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay_loder" v-show="isLoading">
            <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
        </div>
    </div>
</template>

<script>
    import PulseLoader from '@/app/components/PulseLoader.vue'
    import ValidationRule from '@/app/config/validationRule.js'
    import Message from '@/app/components/Message.vue'
export default {
    name: 'CommpanyBraindAdd',
    components: {
        PulseLoader,
        Message
    },
    data: function () {
        return {
            isLoading:false,
            showContent:false,
            ApivalidationMessage:'',
            alertMessage:'入力エラーがあります。',
            addBrandForm: {
                brand_id: null,
                company_name: null,
                url: null,
                brand_name: null,
                zip_code: null,
                address: null,
                department_name:null,
                remarks: null,
                phone_number: null,
                company_manager_pw: null,
                company_manager_pw_confirm: null,
                daily_duplication_company_url: null,
                heat_stroke_enable:0,
            },
            validation:{
                companyidReult: "",
                companyNameReult: "",
                companyurlReult: "",
                companybrand_nameReult: "",
                companypostalcodeReult: "",
                companyaddressReult: "",
                companydepartmentnameReult: "",
                companyremarksReult: "",
                companytellReult: "",
                companypassReult: "",
                companyrepassReult: "",
                companydailyduplicationcompanyurlReult: "",
                companyHeatStrokeEnableResult:"",
            },
            addFormFlg: true
        }
    },
    computed: {
        brandPath: function () {
            // $routeから取得
            return this.$route.params.brandPath
        },
    },
    methods:{
        checkFrom: async function(){

            this.addFormFlg = true;
            this.isLoading = true;

            //エラー内容初期化
            this.clearError();

            //バリデーションチェック(企業コード)
            //必須チェック
            if(!this.addBrandForm.brand_id){
                this.validation.companyidReult="企業コードを入力してください。"
                this.addFormFlg = false;
            }
            if(!this.addBrandForm.url){
                this.validation.companyurlReult="URLを入力してください。"
                this.addFormFlg = false;
            }
            if(!this.addBrandForm.company_manager_pw){
                this.validation.companypassReult="企業管理者パスワードを入力してください。"
                this.addFormFlg = false;
            }
            if(!this.addBrandForm.company_manager_pw_confirm){
                this.validation.companyrepassReult="企業管理者パスワード(確認用)を入力してください。"
                this.addFormFlg = false;
            }
            if(!this.addBrandForm.company_name){
                this.validation.companyNameReult="企業名を入力してください。"
                this.addFormFlg = false;
            }
            if(!this.addBrandForm.brand_name){
                this.validation.companybrand_nameReult="ブランド名を入力してください。"
                this.addFormFlg = false;
            }

            //桁数チェック
            if(String(this.addBrandForm.brand_id).length > 20 && this.validation.companyidReult ==""){
                this.validation.companyidReult="企業コードは20桁以内で入力してください。"
                this.addFormFlg = false;
            }
            if(String(this.addBrandForm.company_name).length > 40 && this.validation.companyNameReult == ""){
                this.validation.companyNameReult="企業名は40桁以内で入力してください。"
                this.addFormFlg = false;
            }
            if(String(this.addBrandForm.url).length > 100 && this.validation.companyurlReult == ""){
                this.validation.companyurlReult="URLは100桁以内で入力してください。"
                this.addFormFlg = false;
            }
            if(String(this.addBrandForm.brand_name).length > 40 && this.validation.companybrand_nameReult == ""){
                this.validation.companybrand_nameReult="ブランド名は40桁以内で入力してください。"
                this.addFormFlg = false;
            }
            if(this.addBrandForm.zip_code !== '' && this.addBrandForm.zip_code !== null){
                if(String(this.addBrandForm.zip_code).length !== 7 && this.validation.companypostalcodeReult == ""){
                    this.validation.companypostalcodeReult="郵便番号は7桁で入力してください。"
                    this.addFormFlg = false;
                }
            }
            if(String(this.addBrandForm.address).length > 40 && this.validation.companyaddressReult == ""){
                this.validation.companyaddressReult="企業住所は40桁以内で入力してください。"
                this.addFormFlg = false;
            }
            if(String(this.addBrandForm.department_name).length > 30 && this.validation.companydepartmentnameReult == ""){
                this.validation.companydepartmentnameReult="担当部署は30桁以内で入力してください。"
                this.addFormFlg = false;
            }
            if(String(this.addBrandForm.remarks).length > 20 && this.validation.companyremarksReult == ""){
                this.validation.companyremarksReult="備考欄は20桁以内で入力してください。"
                this.addFormFlg = false;
            }
            if(this.addBrandForm.phone_number !== '' && this.addBrandForm.phone_number !== null ){
                if((String(this.addBrandForm.phone_number).length < 10 || String(this.addBrandForm.phone_number).length > 11) && this.validation.companytellReult == "") {
                    this.validation.companytellReult = "連絡先電話番号は10桁以上11桁以内で入力してください。"
                    this.addFormFlg = false;
                }
            }
            if((String(this.addBrandForm.company_manager_pw).length < 8 || String(this.addBrandForm.company_manager_pw).length > 128)
                && this.validation.companypassReult == ""){
                this.validation.companypassReult="企業管理者パスワードは8桁以上、128桁以内で入力してください。"
                this.addFormFlg = false;
            }
            if(String(this.addBrandForm.daily_duplication_company_url).length > 100 && this.validation.companydailyduplicationcompanyurlReult == ""){
              this.validation.companydailyduplicationcompanyurlReult="URLは100桁以内で入力してください。"
              this.addFormFlg = false;
            }


            //文字種チェック
            if(this.addBrandForm.brand_id !== null && !this.checkStrong(this.addBrandForm.brand_id) && this.validation.companyidReult == ""){
                this.validation.companyidReult="企業コードは半角英数で入力してください。"
                this.addFormFlg = false;
            }
            if(this.addBrandForm.company_name !== null && !this.checkStrong5(this.addBrandForm.company_name) && this.validation.companyNameReult == ""){
                this.validation.companyNameReult="企業名は全半角英数漢ひらカナ記号（・-ー&＆'’,，.．）スペースで入力してください。"
                this.addFormFlg = false;
            }
            if(this.addBrandForm.url !== null && !this.checkStrong3(this.addBrandForm.url) && this.validation.companyurlReult == ""){
                this.validation.companyurlReult="URLは半角英数記号で入力してください。"
                this.addFormFlg = false;
            }
            if(this.addBrandForm.brand_name !== null && !this.checkStrong5(this.addBrandForm.brand_name) && this.validation.companybrand_nameReult == ""){
                this.validation.companybrand_nameReult="ブランド名は全半角英数漢ひらカナ記号（・-ー&＆'’,，.．）スペースで入力してください。"
                this.addFormFlg = false;
            }
            if(this.addBrandForm.zip_code !== null && this.addBrandForm.zip_code !== ''
                && !this.checkNumberZipCode(this.addBrandForm.zip_code) && this.validation.companypostalcodeReult == ""){
                this.validation.companypostalcodeReult="郵便番号は半角数字で入力してください。"
                this.addFormFlg = false;
            }
            if(this.addBrandForm.address !== null && !this.checkAddress(this.addBrandForm.address) && this.validation.companyaddressReult == ""){
                this.validation.companyaddressReult="企業住所は全半角英数漢ひらカナ記号（・ー-）スペースで入力してください。"
                this.addFormFlg = false;
            }
            if(this.addBrandForm.department_name!== null && !this.checkStrong2(this.addBrandForm.department_name) && this.validation.companydepartmentnameReult == ""){
                this.validation.companydepartmentnameReult="担当部署は全半角英数漢ひらカナ記号（・ー）スペースで入力してください。"
                this.addFormFlg = false;
            }
            if(this.addBrandForm.remarks !== null && !this.checkStrong2(this.addBrandForm.remarks) && this.validation.companyremarksReult == ""){
                this.validation.companyremarksReult="備考欄は全半角英数漢ひらカナ記号（・ー）スペースで入力してください。"
                this.addFormFlg = false;
            }
            if(this.addBrandForm.phone_number !== null && this.addBrandForm.phone_number !== ''
                && !this.checkNumber(this.addBrandForm.phone_number) && this.validation.companytellReult == ""){
                this.validation.companytellReult="連絡先電話番号は半角数字で入力してください。"
                this.addFormFlg = false;
            }
            if(this.addBrandForm.company_manager_pw !== null && !this.checkStrong4(this.addBrandForm.company_manager_pw) && this.validation.companypassReult == ""){
                this.validation.companypassReult="企業管理者パスワードは半角英数記号で入力してください。"
                this.addFormFlg = false;
            }
            if(this.addBrandForm.daily_duplication_company_url !== null && !this.checkStrong3(this.addBrandForm.daily_duplication_company_url) && this.validation.companydailyduplicationcompanyurlReult == ""){
              this.validation.companydailyduplicationcompanyurlReult="URLは半角英数記号で入力してください。"
              this.addFormFlg = false;
            }
            //0か1であること
            if(this.addBrandForm.heat_stroke_enable !== null && this.addBrandForm.heat_stroke_enable !== ''
                && (!this.checkNumber(this.addBrandForm.heat_stroke_enable) || (this.addBrandForm.heat_stroke_enable != 0 && this.addBrandForm.heat_stroke_enable != 1)) && this.validation.companyHeatStrokeEnableResult == ""){
                this.validation.companyHeatStrokeEnableResult="熱中症アラート使用の形式が正しくありません。"
                this.addFormFlg = false;
            }

            // UR形式チェック
            if(this.addBrandForm.url !== null && !this.urlFormatCheck1(this.addBrandForm.url) && this.validation.companyurlReult == ""){
                this.validation.companyurlReult="URLの形式に誤りがあります。"
                this.addFormFlg = false;
            }
            if(this.addBrandForm.url !== null && !this.urlFormatCheck2(this.addBrandForm.url) && this.validation.companyurlReult == ""){
                this.validation.companyurlReult="URLの形式に誤りがあります。"
                this.addFormFlg = false;
            }
            if(this.addBrandForm.daily_duplication_company_url !== null && !this.urlFormatCheck1(this.addBrandForm.daily_duplication_company_url) && this.validation.companydailyduplicationcompanyurlReult == ""){
              this.validation.companydailyduplicationcompanyurlReult="URLの形式に誤りがあります。"
              this.addFormFlg = false;
            }
            if(this.addBrandForm.daily_duplication_company_url !== null && !this.urlFormatCheck2(this.addBrandForm.daily_duplication_company_url) && this.validation.companydailyduplicationcompanyurlReult == ""){
              this.validation.companydailyduplicationcompanyurlReult="URLの形式に誤りがあります。"
              this.addFormFlg = false;
            }

            //pwチェック
            if(this.addBrandForm.company_manager_pw !== this.addBrandForm.company_manager_pw_confirm && this.validation.companypassReult == ""){
                this.validation.companypassReult="パスワードが一致しません。入力しなおしてください。"
                this.addFormFlg = false;
            }

            // バリデーション
            if(!this.addFormFlg){
                this.isLoading = false;
                this.scrollTop();
                return null;
            }

            if(this.addFormFlg == true){

                var apiResponseFlg = true;
                // 企業情報の登録
                await this.$axios
                    .post(this.$apiEndpoint + 'manage/brand/create', this.addBrandForm)
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}
                        apiResponseFlg = false;
                        if (err.customError) {
                            error = Object.assign(error, err.customError);
                            if(error.code == 400){
                                this.ApivalidationMessage =  error.message;
                                this.scrollTop();
                            }
                        }
                        if(error.code !== 400){
                            this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                        }
                    }).finally(()=> this.isLoading = false);

                if(apiResponseFlg){
                    this.openModel()
                }
            }

        },
        //半角英数字のチェック
        checkStrong:function(inputdata){
            var re = new RegExp(/^[0-9A-Za-z]+$/);
            return re.test(inputdata);
        },
        //半角数字のチェック
        checkNumber:function(inputdata){
            var re = new RegExp(/^[0-9]*$/);
            return re.test(inputdata);
        },
        //半角数字のチェック
        checkNumberZipCode:function(inputdata){
            var re = new RegExp(/^[0-9]{7}$/);
            return re.test(inputdata);
        },
        //全半角英数漢ひらカナ
        checkStrong2:function(inputdata){
            var re = new RegExp(ValidationRule.ZenHankakuEiSuuKanaKanjiSpace);
            return re.test(inputdata);
        },
        //半角英数記号 + 記号
        checkStrong3:function(inputdata){
            var re = new RegExp(/^[a-zA-Z0-9-:/.?=&]+$/);
            return re.test(inputdata);
        },
        //半角英数記号 + 記号
        checkStrong4:function(inputdata){
            var re = new RegExp(/^[0-9a-zA-Z!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]*$/);
            return re.test(inputdata);
        },
        //全半角英数漢ひらカナ記号
        checkStrong5:function(inputdata){
            var re = new RegExp(ValidationRule.ZenHankakuEiSuuKanaKanjiSpaceSymbol);
            return re.test(inputdata);
        },
        // URL形式チェック
        urlFormatCheck1:function(inputdata){
            var re = new RegExp(/^(https):\/\/[a-zA-Z0-9-:/.?=&]+$/);
            return re.test(inputdata);
        },
        // URL形式チェック 「/」3つ以上あるか
        urlFormatCheck2:function(inputdata){
            if(inputdata.split("/").length-1 > 3){
                return false;
            }
            return true;
        },
        //住所（全半角英数漢ひらカナ記号（・ー-））
        checkAddress:function(inputdata){
            var re = new RegExp(ValidationRule.Address);
            return re.test(inputdata);
        },
        clearError:function(){
            //メッセージ初期化
            this.validation.companyidReult = "";
            this.validation.companyNameReult = "";
            this.validation.companyurlReult = "";
            this.validation.companybrand_nameReult = "";
            this.validation.companypostalcodeReult = "";
            this.validation.companyaddressReult = "";
            this.validation.companydepartmentnameReult = "";
            this.validation.companyremarksReult = "";
            this.validation.companytellReult = "";
            this.validation.companypassReult = "";
            this.validation.companyrepassReult = "";
            this.validation.companydailyduplicationcompanyurlReult = "";
            this.validation.companyHeatStrokeEnableResult = "";
            this.ApivalidationMessage = "";
        },
        openModel() {
            this.showContent = true;
        },
        closeModel() {
            this.showContent = false;
            this.$router.push({name: 'manageCommpanyBrandList', params: {brand_id: this.userButtanId}});
        },
        scrollTop() {
            window.scrollTo(0,0);
        }
    }
}
</script>